import BaseChart from './BaseChart'
import ItemsHelper from '../chart_helpers/ItemsHelper'
import RootHelper from '../chart_helpers/RootHelper'
import BrushHelper from '../chart_helpers/BrushHelper'

import AxisHelper, {
  cleanCollisions,
  continuousExtentParts,
  padLinear,
  continuousExtentTicks,
} from '../chart_helpers/AxisHelper'
import { continuousExtent, categoricalExtent } from '../chart_helpers/AxisHelper'

import SelectableHelper from '../chart_helpers/SelectableHelper'
import * as COLORS from '../utils/colorUtils'
import { max as d3_max, min as d3_min } from 'd3-array'

import {
  curveCardinal as d3_curveCardinal,
  curveLinear as d3_curveLinear,
  line as d3_line,
  area as d3_area,
} from 'd3-shape'
import { select as d3_select } from 'd3-selection'
import SizeHelper from '../chart_helpers/SizeHelper'
import { layoutLabels } from '../utils/labelUtils'

function colorToGradId(color) {
  let str = `grd-${parseInt(color.replace('#', '0x'))}`
  console.log('WTF', str)
  return str
}
function updateGradientDefs(root, colors) {
  let defs = d3_select(root).selectAll('defs').data([null])
  defs = defs.merge(defs.enter().append('defs'))
  let grads = defs.selectAll('linearGradient').data(colors, d => d)
  grads.exit().remove()
  grads
    .enter()
    .append('linearGradient')
    .attr('id', d => colorToGradId(d))
    .attr('x2', '0%')
    .attr('y2', '100%')
    .each(function (color) {
      d3_select(this)
        .append('stop')
        .attr('offset', '0%')
        .attr('style', `stop-color:${color};stop-opacity:0.2`)
      d3_select(this)
        .append('stop')
        .attr('offset', '100%')
        .attr('style', `stop-color:${color};stop-opacity:0`)
    })
}
export default class LineChartChart extends BaseChart {
  constructor(...args) {
    super(...args)
  }
  static defaultConfig = {
    /**
     * Type of curve. `smooth` curves will interpolate between the data poitns. `shapr` curves will be composed of straight line segments.
     */
    curve: {
      type: String,
      default: 'sharp',
      options: ['smooth', 'sharp'],
      exposed: true,
    },
    /**
     * Show/hide the data points that form each line.
     * DEPRECATED; ahora se usa "pointsSize===0"
     */
    showPoints: {
      type: Boolean,
      default: true,
      exposed: true,
    },
    pointsSize: {
      type: [Number, String],
      default: 2,
      options: ['hidden', 3, 6, 9],
      exposed: true,
    },
    showLineLabel: {
      type: Boolean,
      default: false,
      exposed: true,
    },
    showDatumValues: {
      type: Boolean,
      default: false,
      exposed: true,
    },
    gradientFill: {
      type: Boolean,
      default: false,
      exposed: true,
    },
    AxisHelper: {
      x: {
        getExtent: function (data) {
          if (this.axes.x.scale.type === 'scalePoint') return categoricalExtent(data)
          else return continuousExtent(data, d => d.id)
        },
        getDataType: function (data) {
          let ticks = continuousExtentTicks(data, d => d.id)
          if (ticks.every(n => n.getTime)) return Date
          else if (ticks.some(n => isNaN(Number(n)) || String(n).replaceAll(' ', '') !== String(n)))
            return String
          else return null
        },
        valueFormat: '[D]%Y',
      },
      y: {
        getExtent: function (data) {
          let extent, extentParts
          if (this.config.mode === 'lines') {
            extentParts = continuousExtentParts(data)
            // console.log("extent parts",extentParts)
            extent = continuousExtent(extentParts)
          } else {
            extentParts = continuousExtentParts(data, d => [d.y0, d.y1])
            // console.log("extent parts",extentParts)
            extent = continuousExtent(extentParts)
          }

          if (extent[0] == extent[1]) extent = padLinear(extent, 0.2)
          else if (this.config.AxisHelper.y.showTickValues && this.config.AxisHelper.y.unit) {
            extent = cleanCollisions(this.axes.y, extent, extentParts)
          }

          return extent

          // if(originalExtent[0]>0) extent[0]=0
        },
      },
    },
  }
  static helpers = [
    RootHelper,
    ItemsHelper,
    SelectableHelper,
    SizeHelper,
    AxisHelper,
    BrushHelper,
    // {
    //   class: AxisHelper,
    //   config: {
    //     x:{
    //       getExtent: function (data){
    //         let extent = continuousExtent(data,(d)=>d.id)
    //         // if(this.getValueType('x')==='D' && this.config.AxisHelper.x.scale==='linear') extent = padLinear(extent,0.2)
    //         return extent
    //       },
    //       // valueFormat: '[D]%d %b'
    //     },
    //     y:{
    //       getExtent: function (data){
    //         let extent,extentParts
    //         if(this.config.mode==='lines'){
    //           extentParts = continuousExtentParts(data)
    //           // console.log("extent parts",extentParts)
    //           extent = continuousExtent(extentParts)

    //         } else {
    //           extentParts = continuousExtentParts(data,(d)=>[d.y0,d.y1])
    //           // console.log("extent parts",extentParts)
    //           extent = continuousExtent(extentParts)
    //         }

    //         // extent = padLinear(extent,0.2)

    //         extent = cleanCollisions(this.axes.y, extent, extentParts)

    //         return extent

    //         // if(originalExtent[0]>0) extent[0]=0

    //       }
    //     }
    //   }
    // },
  ]
  checkConsistency() {
    return true
  }
  draw() {
    if (this.config.mode === 'lines') {
      let line = d3_line()
        .defined(d => d.value !== null)
        .curve(this.config.curve === 'smooth' ? d3_curveCardinal : d3_curveLinear)
        .x(d => this.axes.x.func.scale()(d.id))
        .y(d => this.axes.y.func.scale()(d.value))

      //shadow area
      let y0s = this.data.map(d => ({ id: d.id, y0: d3_min(d.value, dd => dd.value) }))

      let area = d3_area()
        .defined(d => d.value !== null)
        .curve(this.config.curve === 'smooth' ? d3_curveCardinal : d3_curveLinear)
        .x(d => this.axes.x.func.scale()(d.id))
        .y0(d => this.axes.y.func.scale()(y0s.find(dd => dd.id === d.parentId).y0))
        .y1(d => this.axes.y.func.scale()(d.value))
      // this.itemsEnter.append('path')
      this.parentItemsEnter.append('path').attr('class', 'line').attr('fill', 'none')
      this.parentItemsEnter.append('path').attr('class', 'shadow').style('pointer-events', 'none')
      // this.itemsEnter.call(drawItem,'enter')
      // this.parentItemsEnter.select('path').attr('d',(d)=>line(d.value)).attr('stroke',(d)=>this.color(d))

      // this.itemsEnterTrans.call(drawItem)
      let self = this
      this.parentItemsEnter
        .select('.line')
        .attr('d', d => line(d.value))
        .attr('stroke', d => this.color(d))
        .attr('stroke-width', d => this.thickness(d))
        // .attr('stroke-dasharray',(d)=>this.strokeDasharray(d))
        .each(function () {
          this._totalLength = this.getTotalLength()
        })
        .attr('stroke-dasharray', function (d) {
          var dashing = self.strokeDasharray(d)
          if (dashing === 'none') dashing = '1 0'
          var dashLength = dashing
            .split(/[\s,]/)
            .map(function (a) {
              return parseFloat(a) || 0
            })
            .reduce(function (a, b) {
              return a + b
            })
          var dashCount = Math.ceil(this._totalLength / dashLength)
          var newDashes = new Array(dashCount).join(dashing + ' ')
          var dashArray = newDashes + ' 0, ' + this._totalLength
          return dashArray
        })
        .attr('stroke-dashoffset', function () {
          return this._totalLength
        })

      this.parentItemsEnter
        .select('.shadow')
        .style('opacity', 0)
        .attr('d', d => {
          return area(d.value)
        })
        .attr('fill', d => {
          if (this.config.gradientFill) return `url(#${colorToGradId(this.color(d))})`
          else return 'none'
        })

      this.parentItemsEnterTrans.select('.line').attr('stroke-dashoffset', 0)
      this.parentItemsEnterTrans.select('.shadow').style('opacity', 1)

      this.parentItems.select('.line').attr('stroke-dasharray', 'none')

      updateGradientDefs(
        this.$root,
        this.config.gradientFill ? this.data.map(d => this.color(d)) : []
      )

      this.parentItemsTrans
        .select('.line')
        .attr('d', d => line(d.value))
        .attr('stroke', d => this.color(d))
        .attr('stroke-dasharray', d => this.strokeDasharray(d))
        .attr('stroke-width', d => this.thickness(d))

      this.parentItemsTrans
        .select('.shadow')
        .style('opacity', 1)
        .attr('d', d => area(d.value))
        .attr('fill', d => {
          if (this.config.gradientFill) return `url(#${colorToGradId(this.color(d))})`
          else return 'none'
        })

      this.parentItemsExitTrans.style('opacity', 0)
    } else {
      let area = d3_area()
        .curve(this.config.curve === 'smooth' ? d3_curveCardinal : d3_curveLinear)
        .defined(d => d.value !== null)
        .x(d => this.axes.x.func.scale()(d.id))
        .y0(d => this.axes.y.func.scale()(d.y0))
        .y1(d => this.axes.y.func.scale()(d.y1))
      let line = d3_line()
        .defined(d => d.value !== null)
        .curve(this.config.curve === 'smooth' ? d3_curveCardinal : d3_curveLinear)
        .x(d => this.axes.x.func.scale()(d.id))
        .y(d => this.axes.y.func.scale()(d.y1))
      this.parentItemsEnter.append('path').attr('class', 'area')
      this.parentItemsEnter.append('path').attr('class', 'separator')
      // this.parentItemsEnter.append('path')
      // this.parentItems.select('path').attr('d',(d)=>area(d.value)).attr('fill',(d)=>this.color(d))
      this.parentItemsEnter
        .select('.area')
        .attr('d', d => {
          return area(
            d.value.map(dd => {
              return { id: dd.id, y0: 0, y1: 0 }
            })
          )
        })
        .attr('fill', d => this.color(d))
      this.parentItemsEnterTrans
        .select('.area')
        .attr('d', d => area(d.value))
        .attr('fill', d => this.color(d))

      this.parentItemsTrans
        .select('.area')
        .attr('d', d => area(d.value))
        .attr('fill', d => this.color(d))

      this.parentItemsEnter
        .select('.separator')
        .attr('d', d => {
          return line(
            d.value.map(dd => {
              return { id: dd.id, y0: 0, y1: 0 }
            })
          )
        })
        .attr('fill', 'none')
        .attr('stroke', (d, i, arr) => (i < arr.length - 1 ? '#fff' : 'none'))
        .attr('stroke-width', 2)
      this.parentItemsEnterTrans
        .select('.separator')
        .attr('d', d => line(d.value))
        .attr('stroke', (d, i, arr) => (i < arr.length - 1 ? '#fff' : 'none'))
      this.parentItemsTrans
        .select('.separator')
        .attr('d', d => line(d.value))
        .attr('stroke', (d, i, arr) => (i < arr.length - 1 ? '#fff' : 'none'))

      this.parentItemsExitTrans.style('opacity', 0)

      this.parentItems.merge(this.parentItemsEnter).sort((a, b) => b.value[0].y0 - a.value[0].y0)
    }

    let items = this.items.merge(this.itemsEnter)

    let breakpoints = items
      .raise()
      .selectAll('.break-point')
      .data(d => (this.config.showPoints && (d.value || d.value == 0) ? [d] : []))
    // .data(d=>[d])
    breakpoints.exit().transition().style('opacity', 0).remove()
    let breakpointsEnter = breakpoints.enter().append('g').attr('class', 'break-point')

    //dots to enlarge click area
    breakpointsEnter.append('circle').attr('r', '20').attr('opacity', 0)

    breakpointsEnter.attr(
      'transform',
      d =>
        `translate(${this.axes.x.func.scale()(d.id)},${this.axes.y.func.scale()(d.y1 || d.value)})`
    )

    breakpoints = breakpoints.merge(breakpointsEnter)
    let dots = breakpoints
      .selectAll('.dot')
      .data(d =>
        this.config.showPoints &&
        this.config.pointsSize !== 'hidden' &&
        this.config.pointsSize !== 0
          ? [null]
          : []
      )
    dots.exit().transition().duration(800).attr('r', 0).style('opacity', 0).remove()
    dots.enter().append('circle').attr('class', 'dot')

    this.itemsEnter
      .select('.break-point')
      .attr(
        'transform',
        d =>
          `translate(${this.axes.x.func.scale()(d.id)},${this.axes.y.func.scale()(
            d.y1 || d.value
          )})`
      )
      .select('.dot')
      .attr(
        'fill',
        this.config.skin === 'light' ? COLORS.SKIN_BACKGROUND : COLORS.SKIN_BACKGROUND_DARK
      )
      .attr('stroke', d => this.color({ id: d.parentId }))
      .attr('r', 0)
    this.itemsEnterTrans.select('.break-point').select('.dot').attr('r', 3)
    this.itemsTrans
      .select('.break-point')
      .attr(
        'transform',
        d =>
          `translate(${this.axes.x.func.scale()(d.id)},${this.axes.y.func.scale()(
            d.y1 || d.value
          )})`
      )
      .select('.dot')
      .attr(
        'fill',
        this.config.skin === 'light' ? COLORS.SKIN_BACKGROUND : COLORS.SKIN_BACKGROUND_DARK
      )
      .attr('stroke', d => this.color({ id: d.parentId }))
      .attr('r', this.config.pointsSize || 3)
    this.itemsExitTrans.select('.dot').attr('opacity', 0)

    let parentItems = this.parentItems.merge(this.parentItemsEnter)
    let lineLabels = parentItems.selectAll('.line-label').data(d => {
      return this.config.showLineLabel ? [d] : []
    })
    lineLabels.exit().transition().style('opacity', 0).remove()
    let lineLabelsEnter = lineLabels.enter().append('g').attr('class', 'line-label')

    lineLabelsEnter
      .append('text')
      .attr('dominant-baseline', 'middle')
      .style('font-weight', 'bold')
      .style('font-size', '15px')
      .text(d => d.id)
    lineLabels = lineLabels.merge(lineLabelsEnter)

    lineLabels
      .selectAll('text')
      .attr('fill', d => COLORS.mapAccessibleColor(this.color(d), this.config.skin))

    layoutLabels(lineLabels, d =>
      this.axes.y.func.scale()(d.value[d.value.length - 1].y1 || d.value[d.value.length - 1].value)
    )

    let x0 = d3_max(this.data, d => d3_max(d.value, dd => this.axes.x.func.scale()(dd.id)))
    x0 = Math.min(this.axes.x.func.scale().range()[1], x0) + 12

    lineLabelsEnter
      .attr('transform', function () {
        return `translate(${x0},${this.y})`
      })
      .style('opacity', 0)
    lineLabels
      .transition()
      .duration(1000)
      .style('opacity', 1)
      .attr('transform', function () {
        return `translate(${x0},${this.y})`
      })

    //datum values
    let datumValues = this.itemsEnter
      .merge(this.items)
      .select('.break-point')
      .selectAll('.datum-value')
      .data(d => (this.config.showDatumValues ? [d] : []))

    this.itemsExit.select('.datum-value').transition().style('opacity', 0).remove()
    datumValues.exit().transition().style('opacity', 0).remove()

    datumValues = datumValues.merge(
      datumValues
        .enter()
        .append('text')
        .attr('class', 'datum-value')
        .style('opacity', 0)
        .style('font-size', '14px')
        .style('font-weight', 'bold')
        .attr('fill', 'currentColor')
    )
    datumValues
      // .text(d => this.formatValue(d.value, 'y'))
      .text(d => this.valueWithUnit(d.value))
      .transition()
      .style('opacity', 1)
    datumValues.attr('text-anchor', 'middle').attr('x', 0).attr('y', -8)
  }
}
